// Create and setup your form here

<template>
  <div>
    <Intro @start="started = true" v-if="!started"></Intro>
    <transition name="fadefast">
      <About v-show="about" @close="about = false"></About>
    </transition>
    <transition name="fade">
      <div
        class="vff vff-about"
        style="transition-delay: 2s"
        v-show="aboutready"
      >
        <button
          class="o-btn-action about-btn"
          style="margin-top: 3rem !important"
          @click="about = true"
        >
          about
        </button>
      </div>
    </transition>
    <Spheres @start="restart()" v-if="submitted && started"> </Spheres>
    <flow-form
      v-if="started && !submitted"
      ref="flowform"
      v-on:step="onStep"
      v-on:complete="onComplete"
      v-on:answer="onAnswer"
      v-on:submit="onSubmit"
      v-bind:questions="questions"
      v-bind:language="language"
      v-bind:standalone="true"
    >
      <!-- Custom content for the Complete/Submit screen slots in the FlowForm component -->
      <!-- We've overriden the default "complete" slot content -->
      <template v-slot:complete>
        <div class="f-section-wrap">
          <p>
            <span class="fh2">Thank you.</span>
            <span class="f-section-text">
              The survey is completed, please submit to enter your thoughts into
              the Spheres.
            </span>
          </p>
        </div>
      </template>

      <!-- We've overriden the default "completeButton" slot content -->
      <template v-slot:completeButton>
        <div class="f-submit" v-if="!submitted">
          <button
            class="o-btn-action"
            ref="button"
            type="submit"
            href="#"
            v-on:click.prevent="onSendData()"
            aria-label="Press to submit"
          >
            <span>{{ language.submitText }}</span>
          </button>
        </div>

        <p class="text-success" v-if="submitted">Submitted succesfully.</p>
      </template>
    </flow-form>
  </div>
</template>

<script>
/*
    Copyright (c) 2020 - present, DITDOT Ltd. - MIT Licence
    https://www.ditdot.hr/en
  */

// Import necessary components and classes
import FlowForm from "../src/components/FlowForm.vue";
import Intro from "../src/components/Intro.vue";
import Spheres from "../src/components/Spheres.vue";
import About from "../src/components/About.vue";

import QuestionModel, {
  QuestionType,
  ChoiceOption,
  LinkOption,
} from "../src/models/QuestionModel";
import LanguageModel from "../src/models/LanguageModel";
// If using the npm package, use the following line instead of the ones above.
// import FlowForm, { QuestionModel, QuestionType, ChoiceOption, LanguageModel } from '@ditdot-dev/vue-flow-form'
import { API_BASE } from "../src/api";

export default {
  name: "example",
  components: {
    FlowForm,
    Intro,
    Spheres,
    About,
  },
  data() {
    return {
      started: false,
      submitted: false,
      completed: false,
      about: false,
      aboutready: false,
      language: new LanguageModel(),
      // Create question list with QuestionModel instances
      questions: [
        new QuestionModel({
          id: "name",
          tagline: "",
          title: "What would you like to be called?",
          description:
            "This name will be publicly shared with the community. Please use text, not emojis.",
          type: QuestionType.Text,
          required: true,
          placeholder: "Start typing here",
        }),
        new QuestionModel({
          id: "break_1",
          title: "Chapter 1: Birth",
          content: "",
          description: "",
          type: QuestionType.SectionBreak,
        }),
        new QuestionModel({
          id: "birth_1",
          tagline: "Chapter 1: Birth",
          title:
            "Were you born in a Country considered a representative democracy?",
          type: QuestionType.MultipleChoice,
          required: true,
          multiple: false,
          allowOther: false,
          options: [
            new ChoiceOption({
              label: "Yes",
            }),
            new ChoiceOption({
              label: "No",
            }),
          ],
        }),
        new QuestionModel({
          id: "birth_2",
          tagline: "Chapter 1: Birth",
          title:
            "Did your parents have a support system such as steady work, close family, financial resources?",
          type: QuestionType.MultipleChoice,
          required: true,
          multiple: false,
          allowOther: false,
          options: [
            new ChoiceOption({
              label: "Some, but not much",
            }),
            new ChoiceOption({
              label: "None",
            }),
            new ChoiceOption({
              label: "A lot",
            }),
          ],
        }),
        new QuestionModel({
          id: "birth_3",
          tagline: "Chapter 1: Birth",
          title:
            "Please tell us your thoughts on how your privilege at birth, or the absence of it influenced who you are today",
          type: QuestionType.LongText,
          required: true,
          placeholder: "Start typing here...",
        }),
        new QuestionModel({
          id: "birth_4",
          tagline: "Chapter 1: Birth",
          title:
            "Do you want to see a random selection of answers of others for this chapter?",
          type: QuestionType.MultipleChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              label: "Yes",
              value: "path_a",
            }),
            new ChoiceOption({
              label: "No, please take me to the next chapter",
              value: "path_b",
            }),
          ],
          jump: {
            path_a: "break_2",
            path_b: "break_3",
          },
        }),
        new QuestionModel({
          id: "break_2",
          title: "",
          content: "",
          description: "~",
          type: QuestionType.SectionBreak,
        }),
        new QuestionModel({
          id: "break_3",
          title: "Chapter 2: Childhood",
          content: "",
          description: "",
          type: QuestionType.SectionBreak,
        }),
        new QuestionModel({
          id: "childhood_1",
          tagline: "Chapter 2: Childhood",
          title:
            "At School, were you different from most of your peers, part of a minority group?",
          type: QuestionType.MultipleChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              label: "Yes",
            }),
            new ChoiceOption({
              label: "No",
            }),
          ],
        }),
        new QuestionModel({
          id: "childhood_2",
          tagline: "Chapter 2: Childhood",
          title:
            "As a child, were you ever worried about food, clothing or school supplies?",
          type: QuestionType.MultipleChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              label: "Yes",
            }),
            new ChoiceOption({
              label: "No",
            }),
          ],
        }),
        new QuestionModel({
          id: "childhood_3",
          tagline: "Chapter 2: Childhood",
          title: "Did you feel safe (physically & emotionally) growing up?",
          type: QuestionType.MultipleChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              label: "Yes",
            }),
            new ChoiceOption({
              label: "No",
            }),
          ],
        }),
        new QuestionModel({
          id: "childhood_4",
          tagline: "Chapter 2: Childhood",
          title:
            "Please share a story about the first time you remember encountering there were differences between you and other kids your age",
          type: QuestionType.LongText,
          required: true,
          placeholder: "Start typing here...",
        }),
        new QuestionModel({
          id: "childhood_5",
          tagline: "Chapter 2: Childhood",
          title:
            "Do you want to see a random selection of answers of others for this chapter?",
          type: QuestionType.MultipleChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              label: "Yes",
              value: "path_a",
            }),
            new ChoiceOption({
              label: "No, please take me to the next chapter",
              value: "path_b",
            }),
          ],
          jump: {
            path_a: "break_4",
            path_b: "break_5",
          },
        }),
        new QuestionModel({
          id: "break_4",
          title: "",
          content: "",
          description: "~",
          type: QuestionType.SectionBreak,
        }),
        new QuestionModel({
          id: "break_5",
          title: "Chapter 3: Youth / Adolescence",
          content: "",
          description: "",
          type: QuestionType.SectionBreak,
        }),
        new QuestionModel({
          id: "youth_1",
          tagline: "Chapter 3: Youth / Adolescence",
          title:
            "Was it easy for you to identify with the gender given to you at birth / by society?",
          type: QuestionType.MultipleChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              label: "Yes",
            }),
            new ChoiceOption({
              label: "No",
            }),
          ],
        }),
        new QuestionModel({
          id: "youth_2",
          tagline: "Chapter 3: Youth / Adolescence",
          title:
            "Were you ever bullied or felt unsafe because of your gender or sexual orientation?",
          type: QuestionType.MultipleChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              label: "Yes",
            }),
            new ChoiceOption({
              label: "No",
            }),
          ],
        }),
        new QuestionModel({
          id: "youth_3",
          tagline: "Chapter 3: Youth / Adolescence",
          title:
            "Were your beliefs (religious or otherwise) seeing as dangerous or strange by the majority in your surroundings?",
          type: QuestionType.MultipleChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              label: "Yes",
            }),
            new ChoiceOption({
              label: "No",
            }),
          ],
        }),
        new QuestionModel({
          id: "youth_4",
          tagline: "Chapter 3: Youth / Adolescence",
          title:
            "Please share a story of your youth when a privilege you took for granted was taken away from you and how that affected your life’s perspective",
          type: QuestionType.LongText,
          required: true,
          placeholder: "Start typing here...",
        }),
        new QuestionModel({
          id: "youth_5",
          tagline: "Chapter 3: Youth / Adolescence",
          title:
            "Do you want to see a random selection of answers of others for this chapter?",
          type: QuestionType.MultipleChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              label: "Yes",
              value: "path_a",
            }),
            new ChoiceOption({
              label: "No, please take me to the next chapter",
              value: "path_b",
            }),
          ],
          jump: {
            path_a: "break_6",
            path_b: "break_7",
          },
        }),
        new QuestionModel({
          id: "break_6",
          title: "",
          content: "",
          description: "~",
          type: QuestionType.SectionBreak,
        }),
        new QuestionModel({
          id: "break_7",
          title: "Chapter 4: Now",
          content: "",
          description: "",
          type: QuestionType.SectionBreak,
        }),
        new QuestionModel({
          id: "now_1",
          tagline: "Chapter 3: Now",
          title: "Do you feel (at least temporarily) financially secure?",
          type: QuestionType.MultipleChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              label: "Yes",
            }),
            new ChoiceOption({
              label: "No",
            }),
          ],
        }),
        new QuestionModel({
          id: "now_2",
          tagline: "Chapter 4: Now",
          title:
            "Do you feel fully accepted by your surroundings (in terms of gender, race and status)?",
          type: QuestionType.MultipleChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              label: "Yes",
            }),
            new ChoiceOption({
              label: "No",
            }),
          ],
        }),
        new QuestionModel({
          id: "now_3",
          tagline: "Chapter 4: Now",
          title:
            "Do you have a network of human resources you can count on in case of an unfortunate life period or event ? (family, friends, support group)?",
          type: QuestionType.MultipleChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              label: "Yes",
            }),
            new ChoiceOption({
              label: "No",
            }),
          ],
        }),
        new QuestionModel({
          id: "now_4",
          tagline: "Chapter 4: Now",
          title:
            "If you have to put yourself on a scale of Privilege from 1 to 100, 1 being very underprivileged and 100 super privileged, what number would you give yourself",
          type: QuestionType.Text,
          required: true,
          placeholder: "Start typing here...",
        }),
        new QuestionModel({
          id: "now_5",
          tagline: "Chapter 4: Now",
          title:
            "Do you want to see a random selection of answers of others for this chapter?",
          type: QuestionType.MultipleChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              label: "Yes",
              value: "path_a",
            }),
            new ChoiceOption({
              label: "No, please take me to the next chapter",
              value: "path_b",
            }),
          ],
          jump: {
            path_a: "break_8",
            path_b: "break_9",
          },
        }),
        new QuestionModel({
          id: "break_8",
          title: "",
          content: "",
          description: "~",
          type: QuestionType.SectionBreak,
        }),
        new QuestionModel({
          id: "break_9",
          title: "",
          content: "",
          description: "Closing: Thoughts on Privilege",
          type: QuestionType.SectionBreak,
        }),
        new QuestionModel({
          id: "closing_1",
          tagline: "Closing: Thoughts on Privilege",
          title:
            "After completing this exercise, do you feel there is a difference in your thoughts regarding Privilege, especially your own?",
          type: QuestionType.MultipleChoice,
          multiple: false,
          required: true,
          options: [
            new ChoiceOption({
              label: "Yes",
            }),
            new ChoiceOption({
              label: "No",
            }),
          ],
        }),
        new QuestionModel({
          id: "closing_2",
          tagline: "Closing: Thoughts on Privilege",
          title:
            "Would you please share with us the most impactful experience you have had regarding Privilege, your own or others",
          type: QuestionType.LongText,
          required: true,
          placeholder: "Start typing here...",
        }),
      ],
    };
  },
  mounted() {
    document.addEventListener("keyup", this.onKeyListener);
    setTimeout(() => (this.aboutready = true), 5000);
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.onKeyListener);
  },
  methods: {
    restart() {
      this.started = false;
      Object.assign(this.$data, this.$options.data());
    },
    onKeyListener($event) {
      // We've overriden the default "complete" slot so
      // we need to implement the "keyup" listener manually.

      if ($event.key === "Enter" && this.completed && !this.submitted) {
        this.onSendData();
      }
    },

    onAnswer(questionAnswered) {
      if (questionAnswered.id == "name") {
        fetch(`${API_BASE}/user`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: questionAnswered.answer }),
        })
          .then((response) => response.text())
          .then((data) => {
            if (data === "exists") {
              document.querySelectorAll(".f-prev")[0].click();
              setTimeout(function () {
                document.querySelectorAll(
                  ".q-is-active .f-description"
                )[0].innerHTML =
                  "<span>please choose a different name, this one has already been taken</span>";
              }, 100);
            }
          });
      }
    },

    /* eslint-disable-next-line no-unused-vars */
    onComplete(completed, questionList) {
      // This method is called whenever the "completed" status is changed.
      this.completed = completed;
    },

    /* eslint-disable-next-line no-unused-vars */
    onSubmit(questionList) {
      // This method will only be called if you don't override the
      // completeButton slot.
      this.onSendData();
    },

    onStep(activeQuestionId, activeQuestion) {
      if (activeQuestionId === "break_2") {
        fetch(`${API_BASE}/list`)
          .then((response) => response.json())
          .then((data) => {
            let random = data.data
              .sort(() => 0.5 - Math.random())
              .filter(function (item) {
                return item.birth_3;
              })
              .slice(0, 3);
            setTimeout(function () {
              const desc = document.querySelectorAll(
                ".q-is-active .f-description"
              )[0];
              if (desc) {
                desc.innerHTML =
                  "<span><q>" +
                  random[0].birth_3 +
                  "</q> – " +
                  random[0].title +
                  "</span><br><br>" +
                  "<span><q>" +
                  random[1].birth_3 +
                  "</q> – " +
                  random[1].title +
                  "</span><br><br>" +
                  "<span><q>" +
                  random[2].birth_3 +
                  "</q> – " +
                  random[2].title +
                  "</span>";
              }
            });
          }, 100);
      }
      if (activeQuestionId === "break_4") {
        fetch(`${API_BASE}/list`)
          .then((response) => response.json())
          .then((data) => {
            let random = data.data
              .sort(() => 0.5 - Math.random())
              .filter(function (item) {
                return item.childhood_4;
              })
              .slice(0, 3);
            setTimeout(function () {
              const desc = document.querySelectorAll(
                ".q-is-active .f-description"
              )[0];
              if (desc) {
                desc.innerHTML =
                  "<span><q>" +
                  random[0].childhood_4 +
                  "</q> – " +
                  random[0].title +
                  "</span><br><br>" +
                  "<span><q>" +
                  random[1].childhood_4 +
                  "</q> – " +
                  random[1].title +
                  "</span><br><br>" +
                  "<span><q>" +
                  random[2].childhood_4 +
                  "</q> – " +
                  random[2].title +
                  "</span>";
              }
            });
          }, 100);
      }
      if (activeQuestionId === "break_6") {
        fetch(`${API_BASE}/list`)
          .then((response) => response.json())
          .then((data) => {
            let random = data.data
              .sort(() => 0.5 - Math.random())
              .filter(function (item) {
                return item.youth_4;
              })
              .slice(0, 3);
            setTimeout(function () {
              const desc = document.querySelectorAll(
                ".q-is-active .f-description"
              )[0];
              if (desc) {
                desc.innerHTML =
                  "<span><q>" +
                  random[0].youth_4 +
                  "</q> – " +
                  random[0].title +
                  "</span><br><br>" +
                  "<span><q>" +
                  random[1].youth_4 +
                  "</q> – " +
                  random[1].title +
                  "</span><br><br>" +
                  "<span><q>" +
                  random[2].youth_4 +
                  "</q> – " +
                  random[2].title +
                  "</span>";
              }
            });
          }, 100);
      }
      if (activeQuestionId === "break_8") {
        fetch(`${API_BASE}/list`)
          .then((response) => response.json())
          .then((data) => {
            let random = data.data
              .sort(() => 0.5 - Math.random())
              .filter(function (item) {
                return item.now_4;
              })
              .slice(0, 3);
            setTimeout(function () {
              const desc = document.querySelectorAll(
                ".q-is-active .f-description"
              )[0];
              if (desc) {
                desc.innerHTML =
                  "<span><q>" +
                  random[0].now_4 +
                  "</q> – " +
                  random[0].title +
                  "</span><br><br>" +
                  "<span><q>" +
                  random[1].now_4 +
                  "</q> – " +
                  random[1].title +
                  "</span><br><br>" +
                  "<span><q>" +
                  random[2].now_4 +
                  "</q> – " +
                  random[2].title +
                  "</span>";
              }
            });
          }, 100);
      }
    },

    onSendData() {
      // Set `submitted` to true so the form knows not to allow back/forward
      // navigation anymore.
      this.$refs.flowform.submitted = true;

      this.submitted = true;

      /* eslint-disable-next-line no-unused-vars */
      const data = this.getData();

      fetch(`${API_BASE}/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
    },

    getData() {
      const data = {
        questions: [],
        answers: [],
      };

      this.questions.forEach((question) => {
        if (question.title) {
          let answer = question.answer;
          if (Array.isArray(answer)) {
            answer = answer.join(", ");
          }

          data.questions.push(question.title);
          data.answers.push(answer);
        }
      });

      return data;
    },
  },
};
</script>

<style lang="css">
@import "../src/assets/css/themes/theme-dark.css";
/* If using the npm package, use the following lines instead of the one above */
/* @import '~@ditdot-dev/vue-flow-form/dist/vue-flow-form.css'; */
/* @import '~@ditdot-dev/vue-flow-form/dist/vue-flow-form.theme-minimal.css'; */

.vff-about {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  padding: 0;
  z-index: 99999;
}
.about-btn {
  position: absolute;
  top: 0;
  right: 3.5rem;
  transform: scale(0.6);
}
@media (max-width: 767px) {
  .about-btn {
    transform: translateY(-2rem) scale(0.6);
    right: 0.8rem;
  }
}
</style>
